export const SHARING_ACCESS = [
  {
    id: 'viewer',
    name: 'Viewer',
    access: 'Read',
  },
  {
    id: 'editor',
    name: 'Editor',
    access: 'Write',
  },
];

export const EDITOR_ONLY_ACCESS = [
  {
    id: 'editor',
    name: 'Editor',
    access: 'Write',
  },
];
